import React from 'react';
import ReactDOM from 'react-dom';

import { CustomerApp } from './CustomerApp';

ReactDOM.render(
  <CustomerApp />,
  document.getElementById('root')
);